import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';
import {getTPAID, getUSERID} from  '../global_helpers/sessionReturn.js';

const state = {
    // mostrecent_client_added: {
    //     id: '',
    //     name: '',
    // },
    clientlist: [],
    client: {
        user_id: "",
        client_name: "",
        client_id: null,
        full_legal_company_name: "",
        company_address: "",
        company_city: "",
        company_state: "",
        company_zip: "",
        company_phone: "",
        company_fax: "",
        company_website: "",
    },
    contact: {
        first_name: "",
        last_name: "",
        email: "",
        phone: ""
    }
    
};

const getters = {
    // getRep_id: (state) => state.user.userID,
    // getNewestClient: (state) => state.mostrecent_client_added,
    getClientList: (state) =>  state.clientlist.clients,
    readClient: (state) => state.client,
    readContact: (state) => state.contact,
};

const actions = {
    async getClient({commit}, id) {
        // returns a client object for the management form
        let authHeader = getAuthHeader();
        axios.get("/client/?client_id="+id, authHeader).then((res) => {
            // console.log(`getClient res: ${JSON.stringify(res.data)}`)
            commit('setClient', res.data.client);
            commit('setContact', res.data.contact);
        });
    },
    
    async clearClient({commit}, tpa_rep){
        commit('clearClientState', tpa_rep);
    },
    
    async createClient({commit}, clientContext){
        let authHeader = getAuthHeader();
        clientContext.client['tpa_id'] = getTPAID();
        clientContext.client['user_id'] = getUSERID();
        axios.post("/client/", clientContext, authHeader).then((res => {
            commit('setClient', res.data.client);
            commit('setContact', res.data.contact);
        }))
    },
    
    async generateClientList({commit}){
        let authHeader = getAuthHeader();
        let tpaID = getTPAID();
        axios.get("client/dropdown/?tpa_id="+tpaID, authHeader).then((response) => {
            commit('setClientList', response.data);
        });
    },
    
    async updateClient({commit}, clientContext){
        console.log(`updateClient clientContext: ${clientContext}`)
        let authHeader = getAuthHeader();
        axios.put("/client/", clientContext, authHeader).then((res)=> {
            console.log(`updateClient res: ${JSON.stringify(res.data)}`)
            commit('setClient', res.data.client);
            commit('setContact', res.data.contact);
        });
    }
};

const mutations = {
    // addClient (state, client) {
    //     state.mostrecent_client_added.id = client.client_id;
    //     state.mostrecent_client_added.name = client.client_name;
    // },
    setClientList (state, list){
        state.clientlist = list;
    },
    setClient(state, client){
        state.client = client;
    },
    setContact(state, contact){
        state.contact = contact;
    },
    clearClientState(state, tpa_rep) {
        state.client = {
            tpa_rep: tpa_rep,
            client_name: "",
            client_id: null,
            full_legal_company_name: "",
            company_address: "",
            company_city: "",
            company_state: "",
            company_zip: "",
            company_phone: "",
            company_fax: "",
            company_website: "",
            first_name: "",
            last_name: "",
            email: "",
            phone: ""
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};